<template lang="pug">
  v-navigation-drawer#navDrawer(:value="theDrawer",app dark fixed temporary hide-overlay height="500" color="primary" @transitionend="drawerClosed")
      v-list
        v-list-item
          v-img.shrink.mr-2(alt='COR_UCC Logo',contain src='../../assets/COR_Logo.png' transition='scale-transition', width="45")
          v-img.shrink.mt-2(alt='COR_UCC Name',contain min-width='100' src='../../assets/LogoTitle_white.png', transition='scale-transition', width="150")
      v-divider
      v-list
        v-list-item
          Welcome
        v-list-item
          About(:fromDrawer="true" :fromMenu="false")
        v-list-item
          Ministries(:fromDrawer="true" :fromMenu="false")
        v-list-item
          Events(:fromDrawer="true" :fromMenu="false")    
        v-list-item
          Media(:fromDrawer="true" :fromMenu="false")
        v-list-item
          Visit(:fromDrawer="true" :fromMenu="false")
        v-list-item
          Offerings(:fromDrawer="true" :fromMenu="false")
        
</template>

<script>
import Welcome from '../MenuItems/Welcome';
import About from '../MenuItems/About';
import Visit from '../MenuItems/Visit';
import Media from '../MenuItems/Media';
import Offerings from '../MenuItems/Offerings';
import Events from '../MenuItems/Events';
import Ministries from '../MenuItems/Ministries';
export default {
  components: {
    Welcome,
    About,
    Visit,
    Media,
    Offerings,
    Events,
    Ministries
  },
  props: {
    adrawer: {
      default: null
    }
  },
  data() {
    return {};
  },
  computed: {
    theDrawer() {
      return this.adrawer;
    }
  },
  methods: {
    drawerClosed() {
      console.log('drawer', this.adrawer);
      this.$emit('update:adrawer', null);
    }
  }
};
</script>

<style lang="stylus" scoped>
#navDrawer
  // opacity 100% !important
</style>
